import { render, staticRenderFns } from "./mcdSelect.vue?vue&type=template&id=635cc1f8&scoped=true&"
import script from "./mcdSelect.vue?vue&type=script&lang=js&"
export * from "./mcdSelect.vue?vue&type=script&lang=js&"
import style0 from "./mcdSelect.vue?vue&type=style&index=0&id=635cc1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cc1f8",
  null
  
)

export default component.exports